// 五个教程子页的完整内容（场景化文案 + 图标步骤）

function guidePage(config) {
  return {
    navPage: 'tutorials',
    isGuide: true,
    guideBadge: config.badge,
    breadcrumbParent: { href: '/tutorials/', label: 'Tutorials' },
    breadcrumbLabel: config.breadcrumbLabel,
    title: config.title,
    intro: config.intro,
    scenarios: config.scenarios,
    openingParagraphs: config.openingParagraphs,
    heroMeta: config.heroMeta,
    bottomCta: config.bottomCta,
    sections: config.sections,
    relatedLinks: config.relatedLinks,
  };
}

export function createTutorialGuidePages(buildPageLinks) {
  return {
    '/tutorials/update/': guidePage({
      badge: 'Update Guide',
      breadcrumbLabel: 'Update Guide',
      title: 'How to Update GB WhatsApp Without Losing Data',
      intro: 'GB WhatsApp cannot auto-update from Google Play. If your app feels slow, shows a version warning, or friends mention new features you do not have, use this guide to install the latest APK over your current version without wiping chats.',
      scenarios: [
        'A popup says your GB WhatsApp version is outdated',
        'New features are missing after your friends updated',
        'You want the latest anti-ban build before daily use',
      ],
      heroMeta: ['5 steps', 'Keep your chats', 'Manual APK update'],
      bottomCta: {
        title: 'Need the newest APK file?',
        text: 'Download the latest version, then install it over your current app using the steps above.',
        button: 'Download latest APK',
        href: '/download/',
      },
      relatedLinks: buildPageLinks(['/tutorials/install/', '/tutorials/backup/', '/tutorials/transfer/', '/download/']),
      sections: [
        {
          step: '01',
          scene: 'Before you tap Install on the new APK',
          heading: 'Backup chats first',
          iconSrc: require('@/assets/tutorials/icon-backup.svg'),
          body: [
            'Most updates go smoothly, but a quick backup is your safety net if the install fails or Android clears app data.',
          ],
          bullets: [
            {
              parts: [
                { text: 'Open ' },
                { text: 'GB WhatsApp', href: '/' },
                { text: ' → Settings → Chats → Back up chats' },
              ],
            },
            'Wait until the backup finishes (check the timestamp)',
            'Stay on Wi-Fi if you have large media folders',
          ],
          tip: 'Do this before every major version jump, not only when something already broke.',
        },
        {
          step: '02',
          scene: 'You are ready to grab the new build',
          heading: 'Download the latest APK',
          iconSrc: require('@/assets/install/step-01-download.svg'),
          body: [
            {
              parts: [
                { text: 'Get the ' },
                { text: 'newest GB WhatsApp APK', href: '/download/' },
                { text: ' from a source you trust. Using an old or repacked file is a common reason updates fail or chats behave oddly.' },
              ],
            },
          ],
          bullets: [
            'Confirm the version number matches the latest release',
            'Delete partial or duplicate APK downloads from your phone',
            'Avoid sites that bundle extra apps or fake “speed booster” tools',
          ],
        },
        {
          step: '03',
          scene: 'Android asks whether to replace the existing app',
          heading: 'Install over the current version',
          iconSrc: require('@/assets/install/step-03-apk.svg'),
          body: [
            'Open the downloaded APK and tap Install. In most cases you do not need to uninstall — installing on top keeps your chats and settings in place.',
          ],
          bullets: [
            'Do not uninstall GB WhatsApp before updating',
            'If blocked, enable Install unknown apps for your browser or file manager',
            'Wait for the “App installed” message before opening the app',
          ],
          tip: 'Seeing “App not installed”? Free up storage or remove a conflicting mod APK first.',
        },
        {
          step: '04',
          scene: 'Right after the update finishes',
          heading: 'Open GB WhatsApp and confirm your data',
          iconSrc: require('@/assets/install/step-06-whatsapp.svg'),
          body: [
            'Launch the app and check that your chats, groups, and settings are still there. Send a test message to one contact before relying on the update for work chats.',
          ],
          bullets: [
            'Scroll through a few old conversations to confirm history loaded',
            'Check that media still opens in chats',
            'Re-enable notification permissions if Android reset them',
          ],
        },
        {
          step: '05',
          scene: 'Optional — verify you are on the right build',
          heading: 'Check the version number',
          iconSrc: require('@/assets/tutorials/icon-update.svg'),
          body: [
            'Confirm the update actually applied so you are not still running an old package by mistake.',
          ],
          bullets: [
            'Go to GB Settings → Help → App info (or About)',
            'Compare the version with the APK page you downloaded from',
            'If it still shows an old number, restart the phone and check again',
          ],
          tip: 'Only download updates from reliable sources. Outdated builds are more likely to crash or miss security fixes.',
        },
      ],
    }),

    '/tutorials/backup/': guidePage({
      badge: 'Backup Guide',
      breadcrumbLabel: 'Backup & Restore',
      title: 'How to Backup and Restore GB WhatsApp Chats',
      intro: 'Back up before updating, switching phones, or moving to GB WhatsApp. This guide focuses on the moments when users actually lose messages — unfinished backups, wrong phone number, or reinstalling too early.',
      scenarios: [
        'You are about to update or transfer to a new phone',
        {
          parts: [
            { text: 'GB WhatsApp', href: '/' },
            { text: ' crashed and you need to reinstall' },
          ],
        },
        'You want a copy of chats before trying a new mod version',
      ],
      heroMeta: ['4 steps', 'Local backup', 'Restore on setup'],
      bottomCta: {
        title: 'Backing up before an update?',
        text: 'Save your chats first, then grab the latest APK when you are ready to upgrade.',
        button: 'Go to download page',
        href: '/download/',
      },
      relatedLinks: buildPageLinks(['/tutorials/transfer/', '/tutorials/update/', '/tutorials/install/', '/tutorials/']),
      sections: [
        {
          step: '01',
          scene: 'When a backup is worth doing',
          heading: 'Know when to back up',
          iconSrc: require('@/assets/tutorials/icon-backup.svg'),
          body: [
            'A backup protects chat history, photos, and voice notes when Android or a failed install wipes app data.',
          ],
          bullets: [
            'Before installing a new GB WhatsApp APK version',
            'Before uninstalling or switching from official WhatsApp',
            'Before factory reset or moving to another Android device',
          ],
        },
        {
          step: '02',
          scene: 'You are inside GB WhatsApp or official WhatsApp',
          heading: 'Create a local backup',
          iconSrc: require('@/assets/install/step-02-settings.svg'),
          body: [
            'Use the built-in chat backup so restore is offered automatically during the next setup.',
          ],
          bullets: [
            'Open Settings → Chats → Chat backup (or Back up chats)',
            'Tap Back Up and wait until the progress bar completes',
            'Note the “Last backup” time — do not reinstall until it is recent',
          ],
          tip: 'Google Drive backup from official WhatsApp does not always carry over to GB WhatsApp. Local backup is the safer path for migration.',
        },
        {
          step: '03',
          scene: 'You reinstalled GB WhatsApp or finished a transfer',
          heading: 'Restore chats during setup',
          iconSrc: require('@/assets/install/step-06-whatsapp.svg'),
          body: [
            'After verifying your number, GB WhatsApp should detect a backup and ask whether to restore.',
          ],
          bullets: [
            'Tap Restore when prompted — do not skip to “Skip” unless you intend to start fresh',
            'Keep the phone unlocked and on power while media reloads',
            'Use the same phone number that created the backup',
          ],
        },
        {
          step: '04',
          scene: 'Backup failed or restore looks incomplete',
          heading: 'Quick checklist',
          iconSrc: require('@/assets/install/step-05-shield.svg'),
          body: [
            'Most restore problems come from these fixable mistakes rather than corrupted backups.',
          ],
          bullets: [
            'Enough free storage for the database and media files',
            'Stable connection if restoring large media folders',
            'Backup completed before uninstalling the old app',
          ],
          avoid: [
            'Uninstalling before the backup finishes',
            'Restoring with a different SIM number than the backup',
            'Clearing app data manually before copying backup folders',
          ],
        },
      ],
    }),

    '/tutorials/verification/': guidePage({
      badge: 'Verification Fix',
      breadcrumbLabel: 'Fix Verification',
      title: 'How to Fix Verification Code Not Received in GB WhatsApp',
      intro: 'Stuck on the OTP screen after install? In most cases the code is delayed by network, SMS filters, or a mistyped number — not a broken APK. Work through these checks before reinstalling.',
      scenarios: [
        'SMS code never arrives after several tries',
        '“Call me” also fails or disconnects instantly',
        'You switched SIMs or traveled to another country',
      ],
      heroMeta: ['6 checks', 'No reinstall first', 'OTP troubleshooting'],
      bottomCta: {
        title: 'Still setting up GB WhatsApp?',
        text: 'If verification keeps failing, reinstall only after you have tried the network and SMS checks above.',
        button: 'View install guide',
        href: '/tutorials/install/',
      },
      relatedLinks: buildPageLinks(['/tutorials/install/', '/tutorials/ban/', '/tutorials/update/', '/tutorials/']),
      sections: [
        {
          step: '01',
          scene: 'The code has not arrived yet',
          heading: 'Test your mobile network',
          iconSrc: require('@/assets/tutorials/icon-verify.svg'),
          body: [
            {
              parts: [
                { text: 'GB WhatsApp', href: '/' },
                { text: ' uses the same SMS verification as official WhatsApp. If your SIM cannot receive normal texts, OTP will fail too.' },
              ],
            },
          ],
          bullets: [
            'Check signal bars — try near a window or outdoors',
            'Send yourself a normal SMS from another phone',
            'Disable airplane mode and confirm mobile data is on',
          ],
        },
        {
          step: '02',
          scene: 'You tapped “Resend code” many times',
          heading: 'Wait, then request one more code',
          iconSrc: require('@/assets/install/step-04-android.svg'),
          body: [
            'Rapid resend requests can trigger short cooldowns on some carriers.',
          ],
          bullets: [
            'Wait 5–10 minutes before the next attempt',
            'Avoid requesting SMS and call verification at the same time',
            'Keep the verification screen open while waiting',
          ],
          tip: 'One patient retry often works better than three quick reinstalls.',
        },
        {
          step: '03',
          scene: 'SMS still does not show up',
          heading: 'Use the Call me option',
          iconSrc: require('@/assets/install/step-05-shield.svg'),
          body: [
            'Voice verification reads the code aloud — useful when SMS inboxes filter automated messages.',
          ],
          bullets: [
            'Tap Call me after the SMS timer expires',
            'Answer the call and write down all six digits',
            'Enter the code before it times out on screen',
          ],
        },
        {
          step: '04',
          scene: 'Network looks fine but nothing changes',
          heading: 'Restart your phone',
          iconSrc: require('@/assets/install/step-02-settings.svg'),
          body: [
            'A restart refreshes the radio connection and clears stuck SMS delivery on some devices.',
          ],
          bullets: [
            'Power off completely, wait 30 seconds, power on',
            'Open GB WhatsApp and request a new code once',
            'Try call verification again if SMS still fails',
          ],
        },
        {
          step: '05',
          scene: 'You are not sure the number is correct',
          heading: 'Double-check country code and digits',
          iconSrc: require('@/assets/tutorials/icon-verify.svg'),
          body: [
            'A wrong country code is one of the most common silent failures — the code goes to a different line.',
          ],
          bullets: [
            'Match the country flag with your SIM’s country',
            'Remove leading zeros from the local number if the UI adds country code separately',
            'Do not include spaces or dashes in the number field',
          ],
        },
        {
          step: '06',
          scene: 'Everything else failed',
          heading: 'Remove blockers and switch network',
          iconSrc: require('@/assets/install/step-03-apk.svg'),
          body: [
            'Third-party SMS apps and strict spam filters often hide OTP messages without showing an error.',
          ],
          bullets: [
            'Temporarily disable SMS blocker or “spam protection” apps',
            'Turn off dual-SIM call forwarding if the wrong line receives SMS',
            'Switch between Wi-Fi and mobile data, then retry once',
          ],
          avoid: [
            'Reinstalling repeatedly without fixing network or SMS filters',
            'Using a virtual number that cannot receive WhatsApp OTP',
            'Requesting dozens of codes in a few minutes',
          ],
        },
      ],
    }),

    '/tutorials/ban/': guidePage({
      badge: 'Ban Prevention',
      breadcrumbLabel: 'Ban Prevention',
      title: 'How to Avoid Getting Banned on GB WhatsApp',
      intro: 'GB WhatsApp offers more privacy and customization options than the official WhatsApp app, but it is still a modified version that is not officially supported by WhatsApp. Because of this, some users may see temporary restrictions or verification problems, especially when using the app in unusual ways.',
      openingParagraphs: [
        {
          parts: [
            { text: 'There is no setting in GB WhatsApp that can guarantee your account will never be banned. However, you can reduce the risk by keeping your ' },
            { text: 'GB WhatsApp APK', href: '/download/' },
            { text: ' updated and using the app like a normal messaging app.' },
          ],
        },
        {
          parts: [
            { text: 'Here are some simple things worth keeping in mind if you use ' },
            { text: 'GBWhatsApp', bold: true },
            { text: ' as your everyday messaging app.' },
          ],
        },
      ],
      scenarios: [],
      heroMeta: ['Safe habits', 'Updated APK', 'Normal use'],
      bottomCta: {
        title: 'Keep your setup current',
        text: 'Download the APK from a source you trust, keep your version updated, and use extra features with common sense.',
        button: 'Download GB WhatsApp APK',
        href: '/download/',
      },
      relatedLinks: buildPageLinks(['/features/hide-online/', '/features/anti-delete/', '/tutorials/install/', '/tutorials/']),
      sections: [
        {
          step: '01',
          heading: 'Keep GB WhatsApp Updated',
          iconSrc: require('@/assets/tutorials/icon-update.svg'),
          body: [
            'Using an old version of GB WhatsApp for too long can cause login, verification, or compatibility problems. Developers of modified apps regularly release new versions to keep up with changes on WhatsApp\'s side.',
            {
              parts: [
                { text: 'If you use GB WhatsApp regularly, check for a newer ' },
                { text: 'GBWhatsApp APK', bold: true },
                { text: ' from the same source you normally use.' },
              ],
            },
            'You don\'t need to delete your chats every time you update. In most cases, you can install the newer version over the existing one, as long as the APK is from a reliable source and is compatible with your current version.',
            'It\'s also better to avoid random APK files claiming to be a special "100% anti-ban" version. There is no genuine version that can promise an account will never be restricted.',
          ],
        },
        {
          step: '02',
          heading: 'Don\'t Use GBWhatsApp Like a Spam Tool',
          iconSrc: require('@/assets/tutorials/icon-ban.svg'),
          body: [
            'One of the easiest ways to make your account look unusual is to send the same message to a large number of people in a short period.',
            'For example, sending the same promotional link to dozens of people you don\'t normally talk to is very different from having regular conversations with your contacts.',
            'If you\'re using GB WhatsApp for personal messaging, try to keep your normal messaging habits:',
          ],
          bullets: [
            'Don\'t send unsolicited messages to lots of unknown numbers.',
            'Avoid forwarding the same link or message to many groups at once.',
            'Don\'t repeatedly send the same message within a few minutes.',
            'Be careful when using bulk messaging or forwarding features.',
          ],
          tip: 'GB WhatsApp may include features that make mass messaging easier, but that doesn\'t mean they should be used aggressively.',
        },
        {
          step: '03',
          heading: 'Be Careful With Auto-Reply and Other Automation Features',
          iconSrc: require('@/assets/install/step-02-settings.svg'),
          body: [
            'Auto-reply is one of the useful features found in many GB WhatsApp versions. It can be handy when you\'re busy or away from your phone, but you probably don\'t need it running for every message all day.',
            'Try using auto-reply only when you actually need it. A simple message such as "I\'m busy right now, I\'ll reply later" looks much more natural than sending the exact same automatic response every time someone contacts you.',
            'The same applies to other automation features included in GB WhatsApp. If a feature makes your account send messages much faster or more frequently than a normal person would, it\'s better to use it sparingly.',
          ],
        },
        {
          step: '04',
          heading: 'Don\'t Keep Switching Between WhatsApp Apps',
          iconSrc: require('@/assets/install/step-05-shield.svg'),
          body: [
            'If you use the same phone number with official WhatsApp and GB WhatsApp, constantly moving the account between the two apps can lead to repeated verification requests and other login issues.',
            'If you decide to use GBWhatsApp, it\'s generally simpler to keep one main setup rather than switching back and forth every few days.',
            'If you have two phone numbers, using one number for each app can also make things easier to manage.',
          ],
        },
        {
          step: '05',
          heading: 'What Should You Do If GB WhatsApp Shows a Ban or Warning?',
          iconSrc: require('@/assets/install/step-05-shield.svg'),
          body: [
            'First, don\'t panic and don\'t immediately install another random GB WhatsApp APK.',
            'If you see a temporary restriction, stop sending messages for a while and check whether you\'re using the latest version of GB WhatsApp. If the problem continues, consider moving the account back to the official WhatsApp app and following WhatsApp\'s account recovery or verification process.',
            'It\'s also a good idea to keep a backup of important chats before making major changes to your setup.',
          ],
        },
        {
          step: '06',
          heading: 'Can GB WhatsApp Guarantee an Anti-Ban Account?',
          iconSrc: require('@/assets/tutorials/icon-ban.svg'),
          body: [
            {
              parts: [
                { text: 'No. Be careful with websites or APK files that promise a ' },
                { text: '"100% anti-ban GB WhatsApp APK."', bold: true },
              ],
            },
            'GB WhatsApp is not an official WhatsApp application, so no modified app can guarantee that an account will never be restricted. An updated version may reduce certain compatibility or login problems, but it cannot completely remove the risk of an account restriction.',
            'The safest approach is simple: keep your GB WhatsApp version reasonably up to date, avoid spam-like behavior, and don\'t rely too heavily on automation features.',
          ],
        },
        {
          step: '07',
          heading: 'Final Thoughts',
          iconSrc: require('@/assets/tutorials/icon-update.svg'),
          body: [
            'Using GB WhatsApp doesn\'t have to mean constantly worrying about getting banned. Most of the problems come from outdated APK files, unusual messaging activity, aggressive automation, or frequently switching between different WhatsApp versions.',
            {
              parts: [
                { text: 'If you choose to use ' },
                { text: 'GB WhatsApp', bold: true },
                { text: ', download the APK from a source you trust, keep your version updated, and use the extra features with some common sense. No ' },
                { text: 'GBWhatsApp', bold: true },
                { text: ' version can guarantee permanent access, but these habits can help you avoid some common problems.' },
              ],
            },
          ],
        },
      ],
    }),

    '/tutorials/transfer/': guidePage({
      badge: 'Transfer Guide',
      breadcrumbLabel: 'Transfer Data',
      title: 'How to Transfer WhatsApp Data to GB WhatsApp',
      intro: 'Moving from official WhatsApp to GB WhatsApp while keeping chats? The safe path is backup first, install GB WhatsApp second, restore third — never uninstall until the backup timestamp is fresh.',
      scenarios: [
        'You want GB features but keep years of chat history',
        'You are switching from official WhatsApp on the same Android phone',
        'Restore did not appear and you need to find the backup folder',
      ],
      heroMeta: ['6 steps', 'Same phone number', 'Chat migration'],
      bottomCta: {
        title: 'Ready to install GB WhatsApp?',
        text: 'Complete your WhatsApp backup first, then follow the install guide on the same device.',
        button: 'Open install guide',
        href: '/tutorials/install/',
      },
      relatedLinks: buildPageLinks(['/tutorials/backup/', '/tutorials/install/', '/tutorials/update/', '/tutorials/']),
      sections: [
        {
          step: '01',
          scene: 'You still have official WhatsApp installed',
          heading: 'Create a WhatsApp backup',
          iconSrc: require('@/assets/tutorials/icon-backup.svg'),
          body: [
            'Everything else depends on a complete backup taken before you change apps.',
          ],
          bullets: [
            'Open official WhatsApp → Settings → Chats → Chat backup',
            'Tap Back Up and wait until it finishes',
            'Note the “Last backup” date and time',
          ],
          tip: 'Do not uninstall WhatsApp until this step is done.',
        },
        {
          step: '02',
          scene: 'You want to confirm the files exist',
          heading: 'Locate the backup folder',
          iconSrc: require('@/assets/install/step-02-settings.svg'),
          body: [
            'Local backups live in internal storage. Knowing the path helps if GB WhatsApp does not detect them automatically.',
          ],
          bullets: [
            'Check Internal storage → Android → media → com.whatsapp → WhatsApp → Databases',
            'Look for msgstore.db.crypt14 (or similar) with a recent date',
            'Use a file manager if the folder is hidden on your phone brand',
          ],
        },
        {
          step: '03',
          scene: 'Backup is confirmed — time for GB WhatsApp',
          heading: 'Install GB WhatsApp APK',
          iconSrc: require('@/assets/tutorials/icon-install.svg'),
          body: [
            {
              parts: [
                { text: 'Install ' },
                { text: 'GB WhatsApp', href: '/' },
                { text: ' alongside or after official WhatsApp, depending on whether you use dual-app mode on your phone.' },
              ],
            },
          ],
          bullets: [
            'Download the latest APK from a trusted page',
            'Enable Install unknown apps if Android blocks the file',
            'Finish installation before opening the app',
          ],
        },
        {
          step: '04',
          scene: 'GB WhatsApp did not offer restore automatically',
          heading: 'Move or match backup data',
          iconSrc: require('@/assets/tutorials/icon-transfer.svg'),
          body: [
            'Some devices need the WhatsApp backup copied into GB WhatsApp’s storage path before setup detects it.',
          ],
          bullets: [
            'Check whether GB WhatsApp shows a restore prompt on first launch',
            'If not, search your file manager for GB WhatsApp’s Databases folder',
            'Copy the latest crypt file only if you understand the folder layout — wrong copies can break restore',
          ],
          tip: 'When in doubt, use the automatic restore prompt instead of manual copying.',
        },
        {
          step: '05',
          scene: 'You are on the GB WhatsApp welcome screen',
          heading: 'Verify the same phone number',
          iconSrc: require('@/assets/install/step-05-shield.svg'),
          body: [
            'Use the exact number tied to the backup. A different SIM means a different account in WhatsApp’s eyes.',
          ],
          bullets: [
            'Enter country code and number carefully',
            'Complete SMS or call verification',
            'Stay on a stable network until login finishes',
          ],
        },
        {
          step: '06',
          scene: 'Verification succeeded — last step',
          heading: 'Restore chats and media',
          iconSrc: require('@/assets/install/step-06-whatsapp.svg'),
          body: [
            'Accept the restore prompt and give the phone time to rebuild media thumbnails.',
          ],
          bullets: [
            'Tap Restore when asked — skipping starts with an empty inbox',
            'Keep the charger connected for large media libraries',
            'Open a few old chats to confirm history and photos loaded',
          ],
        },
      ],
    }),
  };
}
